import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import Color from "../../common/ColorEnum";
import { ImpressionChartStyle } from "./ImpressionCharts.styled";

ChartJS.register(ArcElement, Tooltip, Legend);

const ImpressionCharts = ({
  datasetIdKey,
  data = { confirmed: 0, unConfirmed: 0 },
  module = "",
}) => {  const labelfunction = (tooltipItem) => {
    const statusarr = ["Served", "Engaged"];
    const status = statusarr[tooltipItem.dataIndex];
    const message = `${status} ${module} : ${tooltipItem.parsed}`;
    return message;
  };
  return (
    <ImpressionChartStyle>
      <p className="chartheading">{module}</p>
      <div className="chartdiv">
        <Doughnut
          datasetIdKey={datasetIdKey}
          options={{
            plugins: {
              tooltip: {
                callbacks: {
                  label: labelfunction,
                },
              },
            },
          }}          data={{
            labels: ["Served", "Engaged"],
            fill: false,
            datasets: [
              {
                data: [data.unConfirmed, data.confirmed],
                backgroundColor: [`${Color.snoozed}`, `${Color.online}`],
                hoverOffset: 4,
              },
            ],
          }}
        />
      </div>
    </ImpressionChartStyle>
  );
};

export default ImpressionCharts;
